import { createSlice, Dictionary } from '@reduxjs/toolkit';
import { RootState } from 'Douleutaras/redux/store';
import { SocialAuthState, SocialAuthStatusEnum } from 'Douleutaras/services/auth/types';

const Provider = (): SocialAuthState => ({
  loaded: false,
  loginStatus: {
    status: SocialAuthStatusEnum.Void
  }
});

export const authProvidersSlice = createSlice({
  name: 'authProviders',
  initialState: {
    facebook: Provider(),
    google: Provider()
  } as Dictionary<SocialAuthState>,
  reducers: {
    updateFbLoaded: (state, action) => {
      state.facebook.loaded = action.payload;
    },
    updateFbLoginStatus: (state, action) => {
      state.facebook.loginStatus = {
        ...state.facebook.loginStatus,
        ...action.payload
      };
    },
    updateGoogleLoaded: (state, action) => {
      state.google.loaded = action.payload;
    },
    updateGoogleLoginStatus: (state, action) => {
      state.google.loginStatus = {
        ...state.google.loginStatus,
        ...action.payload
      };
    }
  }
});

export const { updateFbLoaded, updateFbLoginStatus, updateGoogleLoaded, updateGoogleLoginStatus } = authProvidersSlice.actions;
export const selectAuthProviders = (state: RootState) => state.authProviders;
export default authProvidersSlice.reducer;
